<template>
    <div class="modal-window" v-if="store.modalState">
        <header>
            <button type="button" @click="store.hideModal()">&times;</button>
        </header>
        <section>
            <l-map
                ref="map"
                style="height: 100%; width: 100%;"
                :zoom="zoom"
                :center="center"
                @leaflet:load="setDefaultCenter"
                @dblclick="setPosition"
                >
                <l-tile-layer :url="url"></l-tile-layer>
            </l-map>
        </section>
    </div>
</template>
<script>
    import {LMap, LTileLayer} from 'vue2-leaflet';
    import { Icon } from 'leaflet';
    import L from 'leaflet';
    import 'leaflet/dist/leaflet.css';

    export default {
        components: {
            LMap,
            LTileLayer,
            Icon
        },
        data(){
            return {
                url: 'https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}.png',zoom: 12,
                center: [
                    55.76,
                    37.64
                ],
                bounds: null,
                pointer: null,
                findAddress: null

            }
        },
        methods: {
            setDefaultCenter(){
                this.$refs.map.mapObject.doubleClickZoom.disable();
                const address = this.store.order.addresses[this.store.indexAddress];
                if (address.lat !== null && address.lng !== null){
                    this.setCenter([
                        address.lat,
                        address.lng
                    ]);
                    this.setMarker([
                        address.lat,
                        address.lng
                    ]);
                }else {

                    if ("geolocation" in navigator) {
                        navigator.geolocation.getCurrentPosition((position) => {
                            this.setCenter([
                                position.coords.latitude,
                                position.coords.longitude
                            ]);
                        });
                    }else{
                        this.Api
                            .getAddressByIP()
                            .then((response) => {
                                if (response.data.center){
                                    this.setCenter([
                                        response.data.center.lat,
                                        response.data.center.lng
                                    ])
                                }
                            })
                            .catch((error) => {
                                alert(error);
                            })
                    }
                }
            },
            setMarker(coord){
                const
                    map = this.$refs.map.mapObject;
                if (this.pointer !== null){
                    map.removeLayer(this.pointer);
                }
                this.findAddress = null;
                this.Api.getAddressByGps(coord[0], coord[1]).then((response) => {
                    if (typeof response.data.items[0] != "undefined"){
                        const address = response.data.items[0];
                        this.findAddress = address;
                        let container = document.createElement("div");
                        let h3 = document.createElement("h3");
                            h3.innerHTML = address.address;
                        let link = document.createElement("a");
                        link.setAttribute("href", "javascript:void(null);");
                        link.classList.add("map-button");
                        link.innerHTML = "Выбрать";
                        link.addEventListener("click", (event) => {
                            event.preventDefault();
                            this.setAddress(coord[0], coord[1]);
                        });
                        container.appendChild(h3);
                        container.appendChild(link);

                        this.pointer = L
                            .marker(coord);
                        this
                            .pointer
                            .addTo(map)
                            .bindPopup(container)
                            .openPopup(
                                new L.LatLng(coord[0], coord[1])
                            );
                    }

                })

            },
            setCenter(coord){
                const map = this.$refs.map.mapObject;
                map.panTo(
                    new L.LatLng(coord[0], coord[1])
                );
            },
            setAddress(lat, lng){

                const addressSelect = this.store.order.addresses[this.store.indexAddress];
                addressSelect.lat = lat;
                addressSelect.lng = lng;
                if (this.findAddress){
                    this.$set(addressSelect, 'address', this.findAddress.address);
                    addressSelect.address = this.findAddress.address;
                    addressSelect.house = this.findAddress.house;
                    addressSelect.cost = this.findAddress.cost;
                }
                this.store.hideModal();
            },
            setPosition(event){
                const
                    coord = [
                        event.latlng.lat,
                        event.latlng.lng
                    ];
                this.setMarker(coord);
                this.setCenter(coord);
            }
        },
        props: ['store', 'Api'],
        mounted() {
            delete Icon.Default.prototype._getIconUrl;
            Icon.Default.mergeOptions({
                iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
                iconUrl: require('leaflet/dist/images/marker-icon.png'),
                shadowUrl: require('leaflet/dist/images/marker-shadow.png')
            });

        }
    }
</script>
<style lang="scss">
#yacurier-form{
    .map-button{
        background-color: #FFD957;
        border: none;
        color: #60605D;
        border-radius: 5px;
        display: inline-block;
        padding: 10px 20px;
        text-decoration: none;
        transition: all .125s ease-in;
        &:hover{
            background: #ffd043;
        }
    }
    .modal-window {
        background: #FFF;
        bottom: 0;
        display: flex;
        flex-direction: column;
        left: 0;
        padding: 20px;
        position: fixed;
        right: 0;
        top: 0;
        z-index: 1000;

        > header {
            flex-grow: 0;
            flex-shrink: 1;
            margin-bottom: 10px;
            text-align: right;

            button {
                background: none;
                border: none;
                color: #333;
                font-size: 20px;
                margin-left: auto;
                opacity: .45;

                &:hover {
                    opacity: 1;
                }
            }
        }

        > section {
            flex-grow: 1;
            flex-shrink: 0;
            width: 100%;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/blocks/FullForm/components/Map.vue